module.exports = __webpack_public_path__ + "img/invite_mobile.fce3df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomepageMobile/image/invite_mobile.png
// module id = NaMf
// module chunks = 1 2